import * as Yup from 'yup';
import { ErrorMessages } from '../../constants/ErrorMessages';

export const authValidationSchema = Yup.object().shape({
	userName: Yup.string().required(ErrorMessages.Required),
	password: Yup.string().required(ErrorMessages.Required),
});
